import React, {useEffect} from "react";
import {useIsAdmin} from "../../provider/AdminProvder";
import Button from "@mui/material/Button";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {theme} from "../Theme";
import {ThemeProvider} from "@mui/material";

interface EmailConfirmationProps {
    config: {
        contactFound: boolean,
        confirmed: boolean,
    }
}

export function EmailConfirmation(props: EmailConfirmationProps) {

    const isAdmin = useIsAdmin();
    const [open, setOpen] = React.useState(false);

    useEffect(() => {
        if (props.config.contactFound && props.config.confirmed) {
            setTimeout(() => {
                setOpen(true);
                console.log(props.config, 'OMG');
            }, 1000);
        }
    }, []);

    if (isAdmin) {
        return (
            <div style={{backgroundColor: '#eee', padding: '10px', margin: '10px'}}>
                <h3>Email Confirmation Overlay</h3>
                <p>Das Overlay wird auf dieser Seite angezeigt, wenn jemand auf den E-Mail Adresse bestätigen Button in der
                    E-Mail nach dem Absenden des Formulars drückt.</p>
                <p>Dieses Element kann an einer beliebigen Stelle auf einer Seite platziert werden und ist unsichtbar
                    so lange nicht auf den Link geklickt wurde.</p>
            </div>
        )
    }


    return <ThemeProvider theme={theme}>
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                Vielen Dank, dass du deine E-Mail Adresse bestätigt hast!
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <p>
                        Vielen Dank für deine Bestätigung! 🙌
                    </p>
                    <p>
                        Wir freuen uns riesig, dass du Teil unserer Community bist. Bald erhältst du exklusive Updates,
                        spannende Inhalte und tolle Angebote direkt in dein Postfach.
                    </p>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" fullWidth={false} onClick={() => setOpen(false)}>
                    Alles klar!
                </Button>
            </DialogActions>
        </Dialog>
    </ThemeProvider>;

}